<div
  *transloco="let t"
  class="relative w-full overflow-hidden rounded-xl border border-grey-lightGrey bg-grey-lightGrey"
>
  <app-arrow-wrapper
    [arrowRedrawSignal]="arrowRedrawSignal"
    [looping]="looping"
    [showLoopArrow]="!hasDeadline"
    [paddingBottomInRem]="
      hasDeadline ? 0 : !looping && loopingEnabled() ? 8 : 4
    "
  >
    <div class="flex w-full items-center justify-center">
      @for (phase of phases; track phase; let phaseIndex = $index) {
        <div class="flex w-[400px] flex-col">
          @if (!hasDeadline && phaseFrequencyKey()) {
            <div
              class="w-full border-b border-grey-lightGrey bg-grey-lightGrey p-3 text-center text-sm font-medium text-grey"
            >
              {{
                t(
                  'portal.trainings.builder.stepper.settings.form.phaseFrequency.options.' +
                    phaseFrequencyKey()
                ) +
                  ' ' +
                  (phaseIndex + 1)
              }}
            </div>
          }
          <div
            class="flex flex-row justify-center gap-4 p-4"
            [class.pb-16]="!hasDeadline"
          >
            @for (
              courseInstance of phase.courseInstances;
              track courseInstance
            ) {
              <div
                class="element_with_arrowhead box flex flex-col rounded-lg border border-grey-lightGrey bg-white p-4 shadow-md"
                [class]="{
                  loop_enabled: looping && phases.length === phaseIndex + 1,
                }"
              >
                <div class="mt-auto flex justify-between">
                  <div class="flex items-center">
                    <mat-icon class="text-md mr-2 shrink-0 text-orange"
                      >description</mat-icon
                    >
                    <h3 class="text-sm font-semibold text-primary">
                      {{
                        t(
                          'portal.courses.courseTitleKeys.' +
                            courseInstance.name +
                            '.name'
                        )
                      }}
                    </h3>
                  </div>
                  @if (courseInstance.numberOfEnrolledStudents !== undefined) {
                    <div class="flex shrink-0 items-center">
                      <mat-icon class="items-center text-base text-grey"
                        >person</mat-icon
                      >
                      <span class="text-xs font-semibold">
                        {{
                          (courseInstance.numberOfCompletedStudents ?? 0) +
                            ' / ' +
                            courseInstance.numberOfEnrolledStudents
                        }}
                      </span>
                    </div>
                  }
                </div>
                <p class="min-h-24 pt-2 text-sm text-grey">
                  {{
                    t(
                      'portal.courses.courseTitleKeys.' +
                        courseInstance.name +
                        '.description'
                    )
                  }}
                </p>
                @if (courseInstance.courseId) {
                  <div class="mt-auto flex items-center justify-between">
                    <app-link
                      [description]="
                        t('portal.courses.previewDialog.activatorBtn')
                      "
                      [clickAction]="
                        onCoursePreviewClick(courseInstance.courseId)
                      "
                    >
                      <mat-icon class="text-base font-semibold text-blue">
                        open_in_new
                      </mat-icon>
                    </app-link>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </app-arrow-wrapper>
  @if (!hasDeadline) {
    <div
      class="absolute bottom-8 flex w-full flex-col items-center justify-center gap-4"
      [class.opacity-50]="!loopingEnabled()"
    >
      <div
        class="flex items-center gap-4 rounded-full border border-grey-midGrey text-grey"
      >
        <app-slide-toggle
          [checked]="looping"
          [disabled]="!loopingEnabled()"
          (click)="onToggleClick($event)"
        />
        <p [class.pr-3]="looping">
          {{ t('portal.trainings.detailPage.repetition.label') }}
        </p>
        @if (!looping) {
          <mat-icon
            class="hvs-icon box-content py-2 pr-3 text-grey-midGrey"
            [matTooltip]="
              loopingEnabled()
                ? t('portal.trainings.detailPage.repetition.activeTooltip')
                : t('portal.trainings.detailPage.repetition.inactiveTooltip')
            "
            matTooltipPosition="above"
            matTooltipClass="tooltip-above"
          >
            help_outline
          </mat-icon>
        }
      </div>
      @if (!looping && loopingEnabled()) {
        <div class="flex items-center gap-2 rounded-lg bg-white p-4 shadow-md">
          <mat-icon class="text-yellow-500"> lightbulb </mat-icon>
          {{ t('portal.trainings.detailPage.repetition.explanation') }}
        </div>
      }
    </div>
  }
</div>
